import React, { useState } from 'react';
interface BreathingCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  delay?: number;
  onClick?: () => void;
}
const BreathingCard: React.FC<BreathingCardProps> = ({
  title,
  description,
  icon,
  delay = 0,
  onClick
}) => {
  const [ripples, setRipples] = useState<Array<{
    x: number;
    y: number;
    id: number;
  }>>([]);
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const id = Date.now();
    setRipples([...ripples, {
      x,
      y,
      id
    }]);
    setTimeout(() => {
      setRipples(prev => prev.filter(ripple => ripple.id !== id));
    }, 600);
    onClick?.();
  };
  return <div className="relative backdrop-blur-xl bg-white/80 p-8 rounded-3xl border border-gray-100 cursor-pointer overflow-hidden animate-breathing elastic-transition hover:scale-105" style={{
    animationDelay: `${delay}s`
  }} onClick={handleClick} data-id="element-25">
      {ripples.map(ripple => <span key={ripple.id} className="absolute bg-primary-400/30 rounded-full animate-ripple pointer-events-none" style={{
      left: ripple.x,
      top: ripple.y,
      width: '20px',
      height: '20px',
      marginLeft: '-10px',
      marginTop: '-10px'
    }} data-id="element-26" />)}
      <div className="relative z-10" data-id="element-27">
        <div className="bg-gradient-to-br from-primary-100 to-secondary-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 elastic-transition group-hover:scale-110" data-id="element-28">
          <div className="text-primary-600" data-id="element-29">{icon}</div>
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-30">{title}</h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-31">{description}</p>
      </div>
    </div>;
};
export default BreathingCard;